import { createContext, ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/AuthContext";
import RelayAPI from "@/api/RelayAPI";
import { RelayTenant } from "@/Features";

export const RelayInfoContext = createContext<{
  isLoading: boolean;
  relayInfo: RelayTenant | undefined;
  refetch: () => void;
}>({
  isLoading: true,
  relayInfo: undefined,
  refetch: () => {},
});

export const RelayInfoProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { currentUser } = useAuth();
  const tenant = currentUser.licenseInfo.tenant;

  const { isLoading, data, refetch } = useQuery({
    queryKey: [
      "relayInfo",
      {
        cloud_tenant_id: tenant,
        include_logo: true,
        include_instructions: true,
      },
    ],
    queryFn: () =>
      RelayAPI.getRelayInfo({
        cloud_tenant_id: tenant,
        include_logo: true,
        include_instructions: true,
      }),
  });

  if (isLoading) return null;

  const relayInfo = data?.data?.[0];

  return (
    <RelayInfoContext.Provider value={{ isLoading, relayInfo, refetch }}>
      {children}
    </RelayInfoContext.Provider>
  );
};
